import axios from "axios";
import { API_BASE_URL } from "src/modules/data-protection/constants";

export default class OtherAssetProcessingActivityService {
    static getInstance() {
        if (!OtherAssetProcessingActivityService.instance) {
            OtherAssetProcessingActivityService.instance =
                new OtherAssetProcessingActivityService();
        }

        return OtherAssetProcessingActivityService.instance;
    }

    async deleteActivity(payload) {
        const response = await axios.delete(`${API_BASE_URL}/other_asset_processing_activity/remove`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
            },
            data: payload
        });

        return response.data.data;
    }

    async createActivity(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/other_asset_processing_activity/add_module`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data;
    }

    async updateActivity(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/other_asset_processing_activity/update_module`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data;
    }

    async updateActivityResponsiblePerson(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/other_asset_processing_activity/change_analyst`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data;
    }

    async initActivityQuestionnaire(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/other_asset_processing_activity/create`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data;
    }

    async updateActivityQuestionnaire(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/report.update`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data;
    }
}
